import { getIndicatorConfig } from 'utils/common';
import { useFormatNumber } from './index';

type FormatIndicator = (data: any, indicator?: string) => string;

export default function useFormatIndicator(): FormatIndicator {
  const formatNumber = useFormatNumber();

  return function formatIndicator(data: any, indicator?: string): string {
    const { precision } = getIndicatorConfig(indicator);

    return formatNumber(data, precision);
  };
}
